import { useContext, useState } from "react";

import { AppContexts } from "../../../providers";

const BuilderAboutHomeSource = () => {
  const authContext = useContext(AppContexts.AuthContext);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState("");

  const saveSource = async () => {
    setSaving(true);
    setSaved(false);
    setError("");
    try {
      await authContext.updateGuideOnboarding({
        current_step: "about-home",
        source_type: "manual",
        source_url: "",
      });
      setSaved(true);
    } catch (saveError) {
      setError(
        saveError?.response?.data?.error ||
          "We couldn't save that content source. Please try again.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="guide-onboarding-about-source">
      <p className="guide-onboarding-intro">
        Write and organize the About Your Home content yourself, then review
        the guide content below.
      </p>
      <fieldset className="guide-onboarding-source-grid is-custom-only">
        <legend>Content source</legend>
        <div className="guide-onboarding-source is-selected">
          <strong>Custom</strong>
          <span>Write and organize the content yourself.</span>
        </div>
      </fieldset>

      {error && <p className="guide-onboarding-error">{error}</p>}
      <button
        type="button"
        className="uk-button hms-btn hms-white-btn"
        onClick={saveSource}
        disabled={saving}
      >
        {saving ? "Saving…" : saved ? "Source saved" : "Save source"}
      </button>
    </section>
  );
};

export default BuilderAboutHomeSource;
